<div class="card">
    <div class="card-header">
        <i class="fa fa-street-view"></i> Crear Anticipo para cliente {{customer.code}} - {{customer.fullName}}
    </div>
    <div class="card-body card-body-z-index">
        <pos-stepper #cdkStepper linear="true">
            <cdk-step label="Anticipo" [stepControl]="advanceForm">
                <app-advance-create-step [advanceForm]="advanceForm"></app-advance-create-step>
            </cdk-step>
            <cdk-step label="Pagos">
                <app-pos-payment-method (doPayment)="doPayment($event)" [totalAmount]="getTotal()"
                    [customerCode]="customer.code"></app-pos-payment-method>
            </cdk-step>
        </pos-stepper>
    </div>
</div>